import {
  CLOSE_PROGRESSNOTE_SAVE_DISCLAIMER_MODEL,
  CLOSE_PROGRESSNOTE_SAVE_MODEL,
  OPEN_PROGRESSNOTE_SAVE_DISCLAIMER_MODEL,
  OPEN_PROGRESSNOTE_SAVE_MODEL,
} from "./constant";

const initSetting = {
  open_progressnote_save_modal: false,
  open_progressnote_save_disclaimer_modal: false,
};

// eslint-disable-next-line import/prefer-default-export
export const progressNoteModalReducer = (state = initSetting, action = {}) => {
  switch (action.type) {
    case OPEN_PROGRESSNOTE_SAVE_MODEL: {
      return {
        ...state,
        open_progressnote_save_modal: true,
      };
    }
    case CLOSE_PROGRESSNOTE_SAVE_MODEL: {
      return {
        ...state,
        open_progressnote_save_modal: false,
      };
    }
    case OPEN_PROGRESSNOTE_SAVE_DISCLAIMER_MODEL: {
      return {
        ...state,
        open_progressnote_save_disclaimer_modal: true,
      };
    }
    case CLOSE_PROGRESSNOTE_SAVE_DISCLAIMER_MODEL: {
      return {
        ...state,
        open_progressnote_save_disclaimer_modal: false,
      };
    }
    default:
      return state;
  }
};
